import { IAppState } from '../common/state';
import { offerTypeFromJsonQuery, FOfferType } from '../utils/category';

export const getOfferType = ({ results: { jsonQuery } }: IAppState): FOfferType => {
  return offerTypeFromJsonQuery(jsonQuery);
};
